import { Routes, Route, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
//  Users
import Properties from "../component/properties/properties";
import RequestedProperties from "../component/properties/requestedProperties";
import PropertiesDetail from "../component/properties/propertiesDetails";
// Dashboard
import Dashboard from "../component/dashboard/dashboard";
// Admin
import AdminTable from "../component/admin/admins";
import CreateAdmin from "../component/admin/createAdmin";
import EditAdmin from "../component/admin/editAdmin";
// payments
import Tasks from "../component/tasks/tasks";
import CreateTasks from "../component/tasks/createTask";
import EditTasks from "../component/tasks/editTask";
// Leads
import Leads from "../component/leads/leads";
// HR
import SalaryDetails from "../component/hr/salary/salaryDetails";
import Salaries from "../component/hr/salary/salaries";
import AddSalary from "../component/hr/salary/addSalary";
import EditSalary from "../component/hr/salary/editSalary";
// bank
// import SalaryDetails from "../component/hr/salary/salaryDetails";
import AllBankDetails from "../component/hr/bankDetails/bank";
import AddUserBankDetails from "../component/hr/bankDetails/addUserBankDetails";
import EditBankDetails from "../component/hr/bankDetails/editBankDetails";
// login
import Login from "../component/login/login";
// cookie
import cookie from "react-cookies";
// Layout
import Layout from "../shared/layout";

const AllRoutes = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();

  // useEffect for loggedIn user to check
  useEffect(() => {
    let token = cookie.load("token");
    if (token !== undefined) {
      setLoggedIn(true);
    } else {
      navigate("/login");
      setLoggedIn(false);
    }
    // eslint-disable-next-line
  }, [cookie.load("token")]);

  return (
    <React.Fragment>
      {/* login page */}
      {!loggedIn ? (
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      ) : (
        <Layout>
          <Routes>
            {/* Admin */}
            <Route path="/" element={<AdminTable />} />
            <Route path="/add-admin" element={<CreateAdmin />} />
            <Route path="/edit-admin/:id" element={<EditAdmin />} />
            {/* Users */}
            <Route path="/properties" element={<Properties />} />
            <Route
              path="/properties-requests"
              element={<RequestedProperties />}
            />
            <Route path="/properties/:id" element={<PropertiesDetail />} />
            {/* tasks */}
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/create-task" element={<CreateTasks />} />
            <Route path="/create-task/:id" element={<CreateTasks />} />
            <Route path="/edit-task/:id" element={<EditTasks />} />
            {/* leads */}
            <Route path="/leads" element={<Leads />} />
            {/* HR */}
            {/* - Salary - */}
            <Route path="/salary-details" element={<Salaries />} />
            <Route path="/salary-details/:id" element={<SalaryDetails />} />
            <Route path="/add-salary" element={<AddSalary />} />
            <Route path="/edit-salary/:id" element={<EditSalary />} />
            {/* Document */}
            <Route path="/bank" element={<AllBankDetails />} />
            <Route path="/add-bank-details" element={<AddUserBankDetails />} />
            <Route path="/edit-bank-details/:id" element={<EditBankDetails />} />
            {/* Main */}
            <Route path="/" element={<Dashboard />} />
          </Routes>
        </Layout>
      )}
    </React.Fragment>
  );
};
export default AllRoutes;
